// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{flex:1 0 auto;position:initial}.filter-bar .filtered-count{min-width:130px}.filter-bar .filtered-count .results{margin:0;min-width:auto}.filter-bar .filter-options{flex:1 0 0;margin-left:2px;width:auto}.filter-bar .filter-right-side{min-width:70px;position:initial}.filter-bar .search-input{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
